import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  formSection: {
    padding: "4px",
  },
  gridContainer: {
    marginTop: "4px",
  },
  formControl: {
    width: "100%",
  },
  disabledField: {
    opacity: 0.8,
  },
  select: {
    width: "100%",
    "& .MuiSelect-select": {
      padding: "10px",
    },
  },
  inputLabel: {
    fontSize: "15px",
    display: "block",
    marginBottom: "10px",
  },
  inputLabelRight: {
    fontSize: "15px",
    textAlign: "right",
    display: "block",
    marginBottom: "10px",
  },
  causasTextarea: {
    width: "100%",
    "& .MuiInputBase-root": {
      padding: "12px",
      backgroundColor: "#f8f9fa",
    },
  },
  alert: {
    marginBottom: "16px",
  },
  datePicker: {
    width: "100%",
  },
}));
